export default {
  "spanish": {
    "conjugation": {
      "indicativo": {
        "presente": {
          "irregular": {
            "items": [
              {
                "verb": "estar",
                "list": [
                  "estoy",
                  "estás",
                  "está",
                  "estamos",
                  "estáis",
                  "están"
                ]
              },
              {
                "verb": "hablar",
                "list": [
                  "hablo",
                  "hablas",
                  "habla",
                  "hablamos",
                  "habláis",
                  "hablan"
                ]
              },
              {
                "verb": "tener",
                "list": [
                  "tengo",
                  "tienes",
                  "tiene",
                  "tenemos",
                  "tenéis",
                  "tienen"
                ]
              },
              {
                "verb": "ser",
                "list": [
                  "soy",
                  "eres",
                  "es",
                  "somos",
                  "sois",
                  "son"
                ]
              },
              {
                "verb": "haber",
                "list": [
                  "he",
                  "has",
                  "hay",
                  "hemos",
                  "habeís",
                  "han"
                ]
              },
              {
                "verb": "hacer",
                "list": [
                  "hago",
                  "haces",
                  "hace",
                  "hacemos",
                  "hacéis",
                  "hacen"
                ]
              },
              {
                "verb": "dormir",
                "list": [
                  "duermo",
                  "duermes",
                  "duerme",
                  "duermimos",
                  "duermís",
                  "duermen"
                ]
              },
              {
                "verb": "querer",
                "list": [
                  "quiero",
                  "quieres",
                  "quiere",
                  "queremos",
                  "queréis",
                  "quieren"
                ]
              }
            ]
          },
          "reflexivo": {
            "items": [
              {
                "verb": "llamarse",
                "list": [
                  "me llamo",
                  "te llamas",
                  "se llama",
                  "nos llamamos",
                  "os llamáis",
                  "se llaman"
                ]
              },
              {
                "verb": "apellidarse",
                "list": [
                  "me apellido",
                  "te apellidas",
                  "se apellida",
                  "nos apellidamos",
                  "os apellidáis",
                  "se apellidan"
                ]
              },
              {
                "verb": "ir",
                "list": [
                  "me voy",
                  "te vas",
                  "se va",
                  "nos vamos",
                  "os vaís",
                  "se van"
                ]
              }
            ]
          },
          "regular": {
            "items": [
              {
                "verb": "amor",
                "list": [
                  "amo",
                  "amas",
                  "ama",
                  "amamos",
                  "amáis",
                  "aman"
                ]
              },
              {
                "verb": "beber",
                "list": [
                  "bebo",
                  "bebes",
                  "bebe",
                  "bebemos",
                  "bebéis",
                  "beben"
                ]
              },
              {
                "verb": "subir",
                "list": [
                  "subo",
                  "subes",
                  "sube",
                  "subimos",
                  "subís",
                  "suben"
                ]
              },
              {
                "verb": "vivir",
                "list": [
                  "vivo",
                  "vives",
                  "vive",
                  "vivimos",
                  "vivís",
                  "viven"
                ]
              }
            ]
          }
        }
      },
      "subjuntivo": {
        "presente": {
          "regular": {
            "items": [
              {
                "verb": "llevar",
                "list": [
                  "lleve",
                  "lleves",
                  "lleve",
                  "llevemos",
                  "llevéis",
                  "lleven"
                ]
              },
              {
                "verb": "leer",
                "list": [
                  "lea",
                  "leas",
                  "lea",
                  "leamos",
                  "leáis",
                  "lean"
                ]
              },
              {
                "verb": "escribir",
                "list": [
                  "escriba",
                  "escribas",
                  "escriba",
                  "escribamos",
                  "escribáis",
                  "escriban"
                ]
              }
            ]
          }
        }
      }
    }
  }
}